import styled from "styled-components";
import { windowWidth } from "@styles/global";

const Title = styled.div`
  padding-top: 5px;
  font-size: 27px;

  @media ( max-width: ${windowWidth.laptop.large} ) {
    font-size: 23px;
  }
`;

export { Title };